import React from "react";
import { Modal, Button } from "react-bootstrap";

export const CommonModal = ({
  show,
  onHide,
  title,
  children,
  footerActions = [],
  size = "lg",
}) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      backdrop="static"
      size={size}
      scrollable
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{children}</Modal.Body>
      {footerActions.length > 0 && (
        <Modal.Footer>
          {footerActions.map((action, index) => (
            <Button
              key={index}
              variant={action?.variant || "primary"}
              onClick={action?.onClick}
              type={action?.type || "button"}
            >
              {action?.label}
            </Button>
          ))}
        </Modal.Footer>
      )}
    </Modal>
  );
};
